export const initialFormValues = {
    firstName: {
        value: '',
        error: '',
        required: true,
        validate: 'text',
    },
    lastName: {
        value: '',
        error: '',
        required: true,
        validate: 'text',
    },
    groupNumber: {
        value: '',
        error: '',
        required: true,
        validate: 'alphanumericOrSpecialChar',
        truncated: '',
    },
    memberNumber: {
        value: '',
        error: '',
        required: true,
        validate: 'alphanumeric',
    },
    lineOfBusiness: {
        value: '',
    },
    dateOfBirth: {
        value: '',
        error: '',
        required: true,
    },
    // TODO: Get rid of default date of birth and just use date of birth
    defaultDateOfBirth: {
        value: '',
        error: '',
    },
    disclaimerCheck: {
        value: '',
        error: '',
        required: true,
    },
    locationOfService: {
        value: null,
        error: '',
        required: true,
    },
    selectedProvider: {
        value: null,
    },
    selectedService: {
        value: null,
        error: '',
        required: true,
    },
    cae: {
        value: null,
        error: '',
        required: false,
    },
    radius: {
        value: {
            label: '20mi',
            value: 20,
        },
        required: true,
    },
    termsAndConditions: {
        value: null,
    },
    policyNumber: {
        value: null,
    },
    subscriberId: {
        value: '',
    },
    alternateId: {
        value: '',
    },
};
